import React from 'react';
import { Notification } from '@progress/kendo-react-notification';
import { NotificationGroup } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import { ITicket, ITicketProps } from '../../types/Ticket/ITicket';
import { SvgIcon } from '@progress/kendo-react-common';
import { IUserProfile } from '../../types/User/IUserProfile';
import { GameplanApi } from '../../redux/api/GameplanApi';
import * as svg from '@progress/kendo-svg-icons';

interface EffortExceededWarningProps {
    ticket: ITicket
    time: number
    profile: IUserProfile
    actionDateUtc: Date
}

const EffortExceededWarning: React.FC<EffortExceededWarningProps> = ({ ticket, time, profile, actionDateUtc }) => {
    const { data: workstream } = GameplanApi.useGetTicketWorkstreamQuery({ ticketId: ticket.ID }, { skip: !ticket.ID || !ticket.Is_Workstream });
    const { data: allocation } = GameplanApi.useGetTicketAllocationQuery({ ticketId: ticket.ID }, { skip: !ticket.ID || !ticket.Is_Workstream });
    const myAllocation = allocation?.find(a => a.Contact_Id === profile.Id);
    const showGPLimitWarning = ticket?.Is_Workstream && myAllocation && (myAllocation?.Logged_Time + myAllocation?.Logged_NonBill_Time + (time || 0)) > myAllocation?.Assigned_Mins
    const showGPDateWarning = ticket?.Is_Workstream && actionDateUtc && (new Date(actionDateUtc) < new Date(workstream?.Start_Dt) || new Date(actionDateUtc) > new Date(workstream?.End_Dt))

    return (<>
        {(showGPLimitWarning || showGPDateWarning) && <div className={"p-2 k-notification-warning"}>
            <SvgIcon icon={svg.warningTriangleIcon} className='mb-1' /> Warning:&nbsp;
            {showGPLimitWarning && <>You have exceeded your assigned effort for this {profile?.Phrases.CallPhrase} <br /></>}
            {showGPDateWarning && <>You are adding notes outside of the assigned period for this {profile?.Phrases.CallPhrase}</>}
        </div>}
    </>
    );
};

export default EffortExceededWarning;